import {
    Condition,
    ConditionTypes,
    Operators,
    Conditions,
} from "@tenforce/product-fields"
import { FilterParser } from "./index"
import { ConditionDTO } from "../../models/dto/conditions"
import { TextConditionDTO } from "../../models/dto/conditions/TextCondition"

export const TextConditionDTOType = "#TF.TextFieldCondition"
export const TextFieldDefinitionDTOType = "#TF.TextFieldDefinition"
export enum TextOperatorDTO {
    Contains = "Contains",
    IsEmpty = "IsEmpty",
}

const checkIfApplicable = (condition: Condition): boolean => {
    return condition?.type === ConditionTypes.Text
}

const parseFromDTO = (condition: ConditionDTO): Conditions["Text"] => {
    let result: Conditions["Text"] = null
    switch (condition.Operator) {
        case TextOperatorDTO.Contains: {
            if (condition.Value) {
                result = {
                    type: ConditionTypes.Text,
                    operator: Operators.Text.Contains,
                    value: condition.Value,
                    isLocked: condition.IsLocked,
                }
            }
            break
        }
        case TextOperatorDTO.IsEmpty: {
            result = {
                type: ConditionTypes.Text,
                operator: Operators.Text.IsEmpty,
                value: null,
                isLocked: condition.IsLocked,
            }
            break
        }
        default:
            break
    }
    return result
}

const parseToDTO = (
    id: string,
    condition: Condition,
): TextConditionDTO | null => {
    if (!condition || !checkIfApplicable(condition)) {
        return null
    }
    let result: TextConditionDTO | null = null
    switch (condition.operator) {
        case Operators.Text.Contains: {
            if (condition.value) {
                result = {
                    "@type": TextConditionDTOType,
                    Operator: TextOperatorDTO.Contains,
                    Value: condition.value,
                    IsLocked: condition.isLocked,
                    FieldDefinition: {
                        Id: id,
                    },
                }
            }
            break
        }
        case Operators.Text.IsEmpty: {
            result = {
                "@type": TextConditionDTOType,
                Operator: TextOperatorDTO.IsEmpty,
                IsLocked: condition.isLocked,
                FieldDefinition: {
                    Id: id,
                },
            }
            break
        }
        default:
            break
    }
    return result
}

const parser: FilterParser = {
    Type: ConditionTypes.Text,
    DefinitionDTOType: TextFieldDefinitionDTOType,
    checkIfApplicable,
    parseFromDTO,
    parseToDTO,
}
export default parser
